import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import ApiConstants from "../../../api-constants";
import { Participant } from "../../../Types/Participant";
import Constants from "../../../constants";

const fetchCompetitionLeaderboard = async (
  competitionId: string,
  isGross: boolean | null,
  handicapType: string | null,
  leaderboardFormat: number,
  isLeagueLeaderboard: boolean
) => {
  if (isGross == null) {
    throw new AxiosError("isGross must not be null");
  }

  const url = isLeagueLeaderboard
    ? ApiConstants.competitionLeagueLeaderboard
    : ApiConstants.competitionLeaderboard;

  const res = await axios.get(url, {
    headers: {
      Authorization: ApiConstants.authToken,
    },
    params: {
      competitionId,
      leaderBoardFormat: isGross ? 0 : leaderboardFormat,
      tenantId: 1,
      ...(!isGross && handicapType ? { handicapType } : {}),
    },
  });

  if (res.status === 200) {
    return res.data.Participants;
  } else {
    throw new Error(`Unexpected status code: ${res.status}`);
  }
};

function useCompetitionLeaderboard(
  competitionId: string,
  isGross: boolean | null,
  handicapType: string | null,
  leaderboardFormat: number,
  isLeagueLeaderboard: boolean
) {
  const {
    data: participants = [],
    error,
    isLoading,
  } = useQuery<Participant[], AxiosError>(
    [
      "competitionLeaderboard",
      competitionId,
      isGross,
      handicapType,
      isLeagueLeaderboard,
    ],
    () =>
      fetchCompetitionLeaderboard(
        competitionId,
        isGross,
        handicapType,
        leaderboardFormat,
        isLeagueLeaderboard
      ),
    {
      enabled: Boolean(competitionId && isGross !== null), // Fetch only if conditions are met
      refetchInterval: Constants.refreshTime, // Refetch every 20 seconds
      refetchOnWindowFocus: false, // Optional: Avoid refetching on window focus
      initialData: [], // Optional: Return an empty array until data is fetched
      retry: false, // Do not retry if an error occurs
    }
  );

  return { participants, isLoading, error };
}

export default useCompetitionLeaderboard;
